import { useOnValueChange } from '@calendly/hooks';
import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { Body, Footer, Popup } from '@calendly/ui/components/popup';
import { BodyText } from '@calendly/ui/components/typography';
import { TextField } from '@calendly/ui/form/text-field';
import { zIndexModal } from '@calendly/ui/z-index';
import classNames from 'classnames';
import { useContext, useState, forwardRef } from 'react';
import { MeetingDetailDependenciesContext } from '../../../meeting_detail_context';
const modalContentCss = "m17cnmzm";
const ModalContent = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(modalContentCss, props.className)} />;
});
const emailInputCss = "e1jdvpl4";
const EmailInput = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(emailInputCss, props.className)} />);
export const EditEmailModal = ({
  event,
  invitee,
  onClose
}) => {
  const dependencies = useContext(MeetingDetailDependenciesContext);
  if (!dependencies?.useUpdateInviteeMutation) {
    throw new Error('EditEmailModal must be wrapped in a MeetingDetailDependenciesProvider with useUpdateInviteeMutation');
  }
  const [updateInvitee, {
    error,
    isLoading,
    isSuccess
  }] = dependencies.useUpdateInviteeMutation();
  const [email, setEmail] = useState(invitee.email);
  const errors = error?.type === 'validation' ? error.payload.email : [];
  const onConfirm = () => {
    // Pass meeting ids so post-success cache patch can update getScheduledEventSupergraph
    // (root-api-graphql). REST invalidatesTags alone cannot refresh that Supergraph cache.
    updateInvitee({
      id: invitee.id,
      eventId: event?.id,
      eventUuid: event?.uuid,
      attributes: {
        email
      }
    });
  };
  useOnValueChange(isSuccess, () => {
    if (!isSuccess) return;
    onClose();
  });
  return <Popup title={I18n.t('publisher.meetings.edit_email_modal.title')} onClose={onClose} zIndex={zIndexModal}>
      <Body>
        <ModalContent>
          <BodyText>
            {I18n.t('publisher.meetings.edit_email_modal.description')}
          </BodyText>
          <BodyText color="muted" size="medium">
            {I18n.t('publisher.meetings.edit_email_modal.notice')}
          </BodyText>
          <EmailInput type="email" name="email" placeholder={I18n.t('publisher.labels.email')} aria-label={I18n.t('publisher.labels.email')} maxLength={255} value={email} errors={errors} onChange={e => setEmail(e.target.value)} />
        </ModalContent>
      </Body>
      <Footer>
        <Button decoration="secondary-outline" onClick={onClose}>
          {I18n.t('publisher.action.cancel')}
        </Button>
        <Button loading={isLoading} onClick={onConfirm}>
          {I18n.t('publisher.action.update')}
        </Button>
      </Footer>
    </Popup>;
};

require("./edit_email_modal.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./edit_email_modal.js");